import { render, staticRenderFns } from "./CensorHistory.vue?vue&type=template&id=1b09605d&scoped=true&"
import script from "./CensorHistory.vue?vue&type=script&lang=js&"
export * from "./CensorHistory.vue?vue&type=script&lang=js&"
import style0 from "./CensorHistory.vue?vue&type=style&index=0&id=1b09605d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b09605d",
  null
  
)

export default component.exports